import { render, staticRenderFns } from "./PaymentResults.vue?vue&type=template&id=01c43c5c&"
import script from "./PaymentResults.vue?vue&type=script&lang=js&"
export * from "./PaymentResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports